import * as yup from "yup";

import { Shape } from "@/core/yup";

import { CustomerCardFormType } from "../../formType";
import { formSchemaMoralDetails } from "./MoralDetails/formSchema";
import {
    formSchemaPersonal,
    formSchemaPersonalPhysical,
    formSchemaPhysicalDetails,
} from "./PhysicalDetails/formSchema";

const formSchemaContact = yup.object<{}, Shape<MyBrokerApi.Contacts>>({
    phone1: yup.string().phone().required().nullable(),
    phone2: yup.string().phone().nullable(),
    phone3: yup.string().phone().nullable(),
    email: yup.string().email().required().nullable(),
});

const formSchemaDetailsBase = yup.object<{}, Shape<CustomerCardFormType>>({
    personal: formSchemaPersonal.when("isPhysicalPerson", {
        is: true,
        then: (schema) => schema.concat(formSchemaPersonalPhysical),
    }),
    contact: formSchemaContact,
});

export const formSchemaDetails = yup
    .object<{}, Shape<CustomerCardFormType>>()
    .concat(formSchemaDetailsBase)
    .concat(formSchemaMoralDetails)
    .concat(formSchemaPhysicalDetails);
